import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row, Modal, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { BetSlipRow } from './bet_slip_row';
import { Check2Square, XLg, ExclamationTriangleFill } from 'react-bootstrap-icons';
import Numpad from './numpad';
import * as _ from 'lodash';
import { combination } from 'js-combinatorics';
//import './betslip.scss';
import './forza-betslip.scss';
import FetchButton from 'components/general/FetchButton';
import { AWS_BUCKET_URL } from '../../toolkit/constants';
import useInterval from 'toolkit/useHooks/useInterval';
import { ConvertDisplayNumber } from '../../toolkit/NumberUtil';
import { currencyFormatter, parsePlaceBetResponseMsg } from 'toolkit/utils';
import { EnumBetSlipType } from '../../toolkit/Enums';
import { getShopId } from 'stores/auth/services';
import { fetchBalance, updateBalance } from 'stores/auth';
import { getTeamNameHelper } from 'helper/matchDetailHelper';
import {
  removeAllBetSlip,
  setBetSlipCombination,
  setBetSlipSubmitting,
  setBetSlipSystem,
  setResultModalShow,
  setTotal,
  setResponseData,
  getBetSlipMatches,
  updateBetBuilderGroupOdds,
  removeBetBuilderGroup
} from 'stores/betSlip';
import { postPlaceBetReq } from 'stores/betSlip/services';
import useOddTransformer from '../../toolkit/useHooks/useOddsTransformer.js';
import { checkIfLiveEvent, isHandicap90Specifier } from '../../toolkit/utils';
import { useCategoryLimitValidation } from 'toolkit/useHooks/useCategoryLimitValidation';
import useCurrency from 'toolkit/useHooks/useCurrency';

export default function BetSlipList(props) {
  const dispatch = useDispatch();
  const { user, balance, refundBonusBalance } = useSelector((state) => state.auth);
  const { selectedLocale, locales } = useSelector((state) => state.match);
  const betSlip = useSelector((state) => state.betSlip);
  const isBetSlipSubmitting = useSelector((state) => state.betSlip.isBetSlipSubmitting);
  const isBetSlipSubmittingRef = useRef(isBetSlipSubmitting);
  const betSlipEvents = useSelector(
    (state) => {
      const eventsObj = {};
      betSlip.bets.forEach((bet) => {
        const event = state.match.events[bet.providerId];
        if (event) {
          eventsObj[bet.providerId] = event;
        }
      });
      return eventsObj;
    },
    (prev, next) => _.isEqual(prev, next)
  );
  const outrightEvents = useSelector((state) => state.outrights?.events || []);

  const { t } = useTranslation('translations', { useSuspense: false });
  const navigate = useNavigate();
  const [activeSegment, setActiveSegment] = useState(betSlip.system ? 2 : 1);
  const [combinationRelatedBetCount, setCombinationRelatedBetCount] = useState(0);
  const [stakeExpanded, setStakeExpanded] = useState(false);
  const [numpadShow, setNumpadShow] = useState(false);
  const [combinationsExpanded, setCombinationsExpanded] = useState(false);
  const [combinationsText, setCombinationsText] = useState([]);
  const [numberOfBets, setNumberOfBets] = useState(0);
  const [stakePerBet, setStakePerBet] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [maxProfit, setMaxProfit] = useState(0);
  const stakeInput = useRef(null);
  const betSlipTop = useRef(null);
  const betSlipCenter = useRef(null);
  const betSlipBottom = useRef(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showConfirmationRow, setShowConfirmationRow] = useState(false);
  const [timer, setTimer] = useState(6);
  const { code: currencyCode, maxStake } = useCurrency();
  const _currencyFormatter = currencyFormatter(currencyCode, 2);
  const oddsTransformer = useOddTransformer();
  const { validateBetSlipCategoryLimit } = useCategoryLimitValidation();
  const [useBonusBalance, setUseBonusBalance] = useState(
    user.isRefundBonusEnabled && refundBonusBalance > 0 && balance == 0 ? true : false
  );
  const isSingleBet = betSlip.bets.filter((b) => b.enabled).length === 1;

  useEffect(() => {
    isBetSlipSubmittingRef.current = isBetSlipSubmitting;
  }, [isBetSlipSubmitting]);

  const handleRestoreClick = () => {
    setShowSuccessModal(false);
    setTimer(6);
    setShowConfirmationRow(false);
  };

  useInterval(
    () => {
      if (timer > 0) {
        setTimer(timer - 1);
      }
    },
    showSuccessModal ? 1000 : null
  );

  useEffect(() => {
    if (timer === 0) {
      modalCallback(true);
    }
  }, [timer]);

  const goToPreviousPath = () => {
    navigate(-1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (user) {
      dispatch(fetchBalance());
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden' && isBetSlipSubmittingRef.current) {
        handlePageExit();
      }
    };

    const handleBeforeUnload = (event) => {
      if (isBetSlipSubmittingRef.current) {
        event.preventDefault();
        event.returnValue = '';
        handlePageExit();
      }
    };

    const handlePageExit = () => {
      if (isBetSlipSubmittingRef.current) {
        dispatch(setBetSlipSubmitting(false));
        dispatch(setResultModalShow(false));
        setShowSuccessModal(false);
        dispatch(removeAllBetSlip());
      }
    };

    function handleContinueError () {
      dispatch(setResultModalShow(false));
      dispatch(setBetSlipSubmitting(false));
    }

    const handlePageHide = () => {
      if (isBetSlipSubmittingRef.current) {
        handlePageExit();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('pagehide', handlePageHide);
    window.addEventListener('unload', handlePageExit);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('pagehide', handlePageHide);
      window.removeEventListener('unload', handlePageExit);
      handlePageExit();
    };
  }, []);

  useEffect(() => {
    if (betSlip.bets.length === 0) {
      goToPreviousPath();
      return;
    }

    const mCount = _.uniqBy(
      betSlip.bets.filter((b) => b.enabled && !b.banker),
      'providerId'
    ).length;
    setCombinationRelatedBetCount(mCount);

    if (betSlip.system) {
      setCombinationsText(betSlip.combinations.map((c) => ' ' + c + '/' + mCount));
    }
    setNumberOfBets(betSlip.numberOfBets);
    setStakePerBet(betSlip.stakePerBet);
    setTaxAmount(betSlip.tax);
    setMaxProfit(betSlip.maxWinning);
  }, [betSlip]);

  function combinationPress(combination) {
    dispatch(setBetSlipCombination(combination));
  }

  useEffect(() => {
    dispatch(setBetSlipSystem(activeSegment === 2));
  }, [activeSegment]);

  // useEffect(() => {
  //   fetchUser();
  // }, []);

  const deleteAllBets = () => {
    //goToPreviousPath();
    dispatch(removeAllBetSlip());
    // goToPreviousPath();
  };

  const modalCallback = (state) => {
    setShowSuccessModal(false);
    if (state) {
      deleteAllBets();
    }
    dispatch(setResultModalShow(true));
  };

  function changeBetSlipTotal(value) {
    if (
      value > 0 &&
      betSlip.total !== value &&
      (!maxStake || value <= maxStake) &&
      (useBonusBalance ? value <= refundBonusBalance : value <= balance)
    ) {
      dispatch(setTotal(value));
    }
    if (numpadShow) {
      setNumpadShow(false);
    }
    const categoryLimitsValidation = validateBetSlipCategoryLimit(betSlipEvents, value);
    if (!categoryLimitsValidation.valid) {
      dispatch(setResponseData({ success: false, text: categoryLimitsValidation.text }));
      setShowSuccessModal(true);
      return;
    }
  }

  function checkNumpad() {
    //We want to close the confirmation row if the user changes the stake for accidental confirmation
    setShowConfirmationRow(false);

    stakeInput.current.blur();
    setNumpadShow(true);
  }

  function changeBonusBalance(event) {
    if (balance == 0) return;
    setUseBonusBalance(event);
  }

  async function placeBet() {
    dispatch(setBetSlipSubmitting(true));
    const customerBalance = await dispatch(fetchBalance());
    if ((!useBonusBalance && customerBalance.payload.balance <= 0) || customerBalance.error) return;

    if (!user) {
      dispatch(setResponseData({ success: false, text: t('pleaseLogin') }));
      dispatch(setResultModalShow(true));
      return;
    }
    const categoryLimitsValidation = validateBetSlipCategoryLimit(betSlipEvents, betSlip.total);
    if (!categoryLimitsValidation.valid) {
      dispatch(setResponseData({ success: false, text: categoryLimitsValidation.text }));
      dispatch(setResultModalShow(true));
      return;
    }

    if (betSlip.system === false && betSlip.bets.length > 15) {
      dispatch(setResponseData({ success: false, text: t('numberofmatch') }));
      dispatch(setResultModalShow(true));
      return;
    }

    if (betSlip.system && betSlip.bets.length > 12) {
      dispatch(setResponseData({ success: false, text: t('systemnumberofmatch') }));
      dispatch(setResultModalShow(true));
      return;
    }

    try {
      const totalStake = betSlip.total;
      const combinations = betSlip.combinations;
      const customOddsMultiplier = betSlip.customOddsMultiplier || 1.0;

      // Separate bet builder bets from normal bets
      const enabledBets = betSlip.bets.filter((b) => b.enabled);
      const betBuilderBets = enabledBets.filter((b) => b.isBetBuilder);
      const normalBets = enabledBets.filter((b) => !b.isBetBuilder);

      // Group bet builder bets by BetBuilderId
      const betBuilderGroups = _.groupBy(betBuilderBets, 'betBuilderId');
      const betBuilderInfo = {};

      // A custom bet is only playable at the MyOdds price; never send a made-up one
      const unpricedGroup = Object.values(betBuilderGroups).some(
        (groupBets) => !(groupBets[0].betBuilderCalculatedOdds > 1)
      );
      if (unpricedGroup) {
        dispatch(setResponseData({ success: false, text: t('betBuilder.recalculate') }));
        dispatch(setResultModalShow(true));
        dispatch(setBetSlipSubmitting(false));
        return;
      }

      // Process bet builder groups to create BetBuilderInfo
      Object.keys(betBuilderGroups).forEach((betBuilderId) => {
        const groupBets = betBuilderGroups[betBuilderId];
        const firstBet = groupBets[0];
        
        const calculatedOdds = firstBet.betBuilderCalculatedOdds;

        const groupHasMaradonaHandicap = groupBets.some((bet) =>
          isHandicap90Specifier(bet.marketStringId)
        );
        const effectiveMultiplier = groupHasMaradonaHandicap ? 1.0 : customOddsMultiplier;

        
        const calculatedOddsWithMultiplier = calculatedOdds * effectiveMultiplier;

        // For BetBuilderInfo, both Odds and ReferenceOdds should use calculatedOddsWithMultiplier
        // When customOddsMultiplier is 1, they will be the same (both = calculatedOdds)
        // Odds field: use the calculated odds with multiplier (API expects this format)
        const totalOdds = calculatedOddsWithMultiplier;

        // ReferenceOdds should be the same as Odds when customOddsMultiplier is 1
        const totalReferenceOdds = calculatedOddsWithMultiplier;

        // Check if any bet in the group is a banker bet
        const isBankoBet = groupBets.some((bet) => bet.banker);

        betBuilderInfo[parseInt(betBuilderId)] = {
          Odds: totalOdds,
          ReferenceOdds: totalReferenceOdds,
          IsBankoBet: isBankoBet
        };
      });

      const outcomes = enabledBets.map((b) => {
        // For outright bets, prefer live data from the outrights store; fall
        // back to the snapshot embedded on the bet by OutrightOddButton.
        const isOutrightBet = !!b.match?.isOutright;
        const liveOutright = isOutrightBet
          ? outrightEvents.find((e) => e?.se?.id === b.providerId)
          : null;
        const event = isOutrightBet
          ? (liveOutright
              ? { ...b.match, markets: liveOutright.markets || b.match.markets }
              : b.match)
          : betSlipEvents[b.providerId];
        const markets = event?.markets?.filter((m) => m.stringId === b.marketStringId) || [];
        const outcomesFound =
          markets.length > 0 ? markets[0].outcomes.filter((o) => o.id === b.outcomeId) : [];
        const odds =
          outcomesFound.length > 0 || isOutrightBet
            ? oddsTransformer.transformWithDisplayFormatted(
                checkIfLiveEvent(b.match),
                b.match?.isSeason,
                b?.marketId,
                new Date(b.match.gameDate),
                b.odds,
                b.marketStringId
              )
            : -1;

        const outcome = {
          eventId: b.providerId,
          marketId: b.marketStringId,
          outcomeId: b.outcomeId,
          odds: odds,
          referenceOdds: b.odds,
          banker: b.banker
        };

        // Add bet builder fields if it's a bet builder bet
        if (b.isBetBuilder && b.betBuilderId !== undefined) {
          outcome.IsBetBuilderOutcome = true;
          outcome.BetBuilderId = b.betBuilderId;
        } else {
          outcome.IsBetBuilderOutcome = false;
        }

        return outcome;
      });

      // An outcome lost its odds (suspended / removed): refresh the slip instead of reloading the page
      if (outcomes.some((o) => o.odds <= 1 || o.odds === 0 || o.odds === null)) {
        dispatch(getBetSlipMatches());
        dispatch(setResponseData({ success: false, text: t('oddsUpdatedTryAgain') }));
        dispatch(setResultModalShow(true));
        dispatch(setBetSlipSubmitting(false));
        return;
      }

      const betSlipType = betSlip.system
        ? EnumBetSlipType.SYSTEM
        : outcomes.length === 1
        ? EnumBetSlipType.SINGLE
        : EnumBetSlipType.MULTIPLE;

      const betRequest = {
        betSlipType: betSlipType,
        totalStake: totalStake,
        isAutomaticCashOutEnabled: false,
        automaticCashOutExecutionThreshold: 500,
        combinations: combinations,
        outcomes: outcomes,
        shopId: getShopId(),
        totalOdds: stakePerBet,
        maxWinning: maxProfit,
        accountType: useBonusBalance ? 5100 : 5000
      };

      // Add BetBuilderInfo if there are any bet builder bets
      if (Object.keys(betBuilderInfo).length > 0) {
        betRequest.BetBuilderInfo = betBuilderInfo;
      }

      if (useBonusBalance) {
        localStorage.setItem('useBonusBalance', 'true');
      } else {
        localStorage.removeItem('useBonusBalance');
      }

      const response = await postPlaceBetReq(betRequest);

      dispatch(fetchBalance());

      const eventGetterFunc = (eventId) => {
        return betSlip.bets.find((b) => b.providerId === eventId);
      };

      if (response.data.success === false) {
        const firstMessage = response.data.messages[0];
        if (firstMessage?.code === 'B021') {
          // The server re-priced the custom bet: show its odds on the slip so the customer can confirm again
          dispatch(
            updateBetBuilderGroupOdds({
              betBuilderId: Number(firstMessage.extraParam1),
              calculatedOdds: Number(firstMessage.extraParam2) / customOddsMultiplier
            })
          );
        }
        if (response.data.messages[0]?.text.includes('400')) {
          response.data.messages[0].text = t('notenoughbalance');
        } else if (response.data.messages[0]?.code == 'O001') {
          response.data.messages[0].text = t('maxbetslip');
        } else {
          response.data.messages[0].text = parsePlaceBetResponseMsg(
            response.data.messages[0],
            t,
            _currencyFormatter,
            eventGetterFunc,
            locales,
            selectedLocale
          );
        }
      }

      dispatch(
        setResponseData({
          success: response.data.success,
          text: response.data.messages[0]?.text
        })
      );
      dispatch(updateBalance(totalStake));
      if (response.data.success === false) {
        dispatch(setResultModalShow(true));
      } else {
        if (isBetSlipSubmittingRef.current) {
          setShowSuccessModal(true);
        }
      }
    } catch (error) {
      console.log(error);
      dispatch(setResponseData({ success: false, text: error.message }));
      setShowSuccessModal(true);
    }
    dispatch(setBetSlipSubmitting(false));
  }

  const calculateBetSlipRowContainerHeight = () => {
    if (betSlipTop && betSlipTop.current && betSlipBottom && betSlipBottom.current) {
      const betSlipTopHeight = betSlipTop.current.offsetHeight;
      const betSlipBottomHeight = betSlipBottom.current.offsetHeight;
      const headerHeight = 56;
      if (betSlipCenter && betSlipCenter.current) {
        betSlipCenter.current.style.setProperty(
          '--betSlipCenterHeight',
          `calc(100vh - ${betSlipTopHeight + betSlipBottomHeight + headerHeight + 90}px)`
        );
        betSlipCenter.current.style.setProperty(
          '--betSlipCenterTopOffset',
          `${headerHeight + betSlipTopHeight}px`
        );
        betSlipCenter.current.classList.add('calculated-height');
      }
    }
  };

  useEffect(() => {
    calculateBetSlipRowContainerHeight();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      calculateBetSlipRowContainerHeight();
      if (betSlipCenter && betSlipCenter.current) {
        betSlipCenter.current.scrollTop = betSlipCenter.current.scrollHeight;
      }
    }, 50);
  }, [stakeExpanded, combinationsExpanded, activeSegment]);

  return (
    <div className={props.type == 'desktop' ? 'card-body' : 'bet-slip-container'}>
      <div
        className={props.type == 'desktop' ? 'container-fluid' : 'bet-slip-top container-fluid'}
        ref={betSlipTop}>
        <Row className="align-items-center flex-nowrap">
          {props.type !== 'desktop' ? (
            <div className="col-auto">
              <div className="top-header-right" style={{ cursor: 'pointer' }}>
                <button
                  className="btn p-0"
                  disabled={betSlip.isBetSlipSubmitting}
                  onClick={() => goToPreviousPath()}>
                  <img src={`${AWS_BUCKET_URL}/Icons/117.png`} alt={'close'} />
                </button>
              </div>
            </div>
          ) : null}
          <Col>
            <a
              onClick={() => setActiveSegment(1)}
              className={
                'bet-slip-segment-button' +
                (activeSegment == 1 ? `${' segment-active'}` : '') +
                ' ' +
                `${isSingleBet ? '' : 'px-2 fs-9'}`
              }>
              {isSingleBet
                ? t('single')
                : `${t('combination')}(${betSlip.bets.filter((b) => b.enabled).length})`}
            </a>
            <a
              onClick={() => {
                setActiveSegment(2);
                setCombinationsExpanded(true);
              }}
              className={
                'bet-slip-segment-button' +
                (activeSegment == 2 ? `${' segment-active'}` : '') +
                ' ' +
                `${isSingleBet ? '' : 'pe-2 fs-9'}`
              }>
              {isSingleBet
                ? t('system')
                : `${t('system')}(${betSlip.bets.filter((b) => b.enabled).length})`}
            </a>
          </Col>
          {user && props.type != 'desktop' ? (
            user.isRefundBonusEnabled && refundBonusBalance > 0 ? (
              <div className="col-auto fw-bold d-flex flex-column">
                <div className="d-flex justify-content-between align-items-center gap-2">
                  <span>{t('balance')}:</span>
                  <span className="fs-9">
                    {balance.toLocaleString('de-DE', {
                      minimumFractionDigits: 2
                    }) + ' ' + currencyCode}
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center gap-2">
                  <span>{t('bonus')}:</span>
                  <span className="fs-9">
                    {refundBonusBalance.toLocaleString('de-DE', {
                      minimumFractionDigits: 2
                    }) + ' ' + currencyCode}
                  </span>
                </div>
              </div>
            ) : (
              <div className="col-auto fw-bold d-flex gap-2">
                <div>
                  <span>{t('balance')}:</span>
                  <br />
                  <span className="fs-9">
                    {balance.toLocaleString('de-DE', {
                      minimumFractionDigits: 2
                    }) + ' ' + currencyCode}
                  </span>
                </div>
              </div>
            )
          ) : null}
        </Row>
      </div>
      <div className={props.type == 'desktop' ? '' : 'bet-slip-center'} ref={betSlipCenter}>
        {/* Group bet builder bets by betBuilderId */}
        {(() => {
          const betBuilderBets = betSlip.bets.filter(bet => bet.isBetBuilder);
          const normalBets = betSlip.bets.filter(bet => !bet.isBetBuilder);
          
          // Group bet builder bets by betBuilderId (not providerId)
          const betBuilderGroups = _.groupBy(betBuilderBets, 'betBuilderId');
          
          return (
            <>
              {/* Render bet builder groups - one per betBuilderId */}
              {Object.keys(betBuilderGroups).map(betBuilderId => {
                const groupBets = betBuilderGroups[betBuilderId];
                const firstBet = groupBets[0];
                const match = betSlipEvents[firstBet.providerId];
                const calculatedOdds = firstBet.betBuilderCalculatedOdds;
                // Without a MyOdds price the group cannot be placed (see placeBet), so say so up front
                const isPriced = calculatedOdds > 1;

                return (
                  <div
                    key={`betbuilder-${betBuilderId}`}
                    className={`bet-builder-group${isPriced ? '' : ' bet-builder-group-stale'}`}>
                    <div className="bet-builder-group-header">
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-center bet-builder-group-title-wrap">
                          <i className="fas fa-puzzle-piece bet-builder-icon me-2"></i>
                          <span className="bet-builder-group-title">
                            {match ? `${getTeamNameHelper(locales, selectedLocale, match.competitors[0], t)} vs ${getTeamNameHelper(locales, selectedLocale, match.competitors[1], t)}` : 'Bet Builder'}
                          </span>
                        </div>
                        <div className="d-flex align-items-center">
                          <span className="bet-builder-group-odds text-white fw-bold">
                            {isPriced ? parseFloat(calculatedOdds).toFixed(2) : '-'}
                          </span>
                          <button
                            type="button"
                            className="bet-builder-group-remove"
                            onClick={() => dispatch(removeBetBuilderGroup({ betBuilderId: firstBet.betBuilderId }))}
                            aria-label={t('betBuilder.removeCustomBet', 'Remove custom bet')}>
                            <XLg size={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                    {!isPriced && (
                      <div className="bet-builder-group-warning" role="alert">
                        <ExclamationTriangleFill size={14} className="me-2 flex-shrink-0" />
                        <span>{t('betBuilder.recalculate')}</span>
                      </div>
                    )}
                    <div className="bet-builder-group-content">
                      {/* Render only the first bet as a representative of the group */}
                      <BetSlipRow key={firstBet.providerId + firstBet.marketStringId + firstBet.outcomeId + firstBet.betBuilderId} bet={firstBet} />
                    </div>
                  </div>
                );
              })}
              
              {/* Render normal bets - group by providerId to avoid duplication */}
              {(() => {
                // Group normal bets by providerId (match)
                const normalBetGroups = _.groupBy(normalBets, 'providerId');
                
                // Render one BetSlipRow per providerId (each row will show all bets for that match)
                return Object.keys(normalBetGroups).map(providerId => {
                  const matchBets = normalBetGroups[providerId];
                  const firstBet = matchBets[0];
                  // Use the first bet as representative - BetSlipRow will show all bets for this providerId
                  return (
                    <BetSlipRow 
                      key={providerId} 
                      bet={firstBet} 
                    />
                  );
                });
              })()}
            </>
          );
        })()}
        <div>
          <div className="text-danger text-decoration-underline" onClick={() => deleteAllBets()}>
            {t('deleteAllBets')}
          </div>
        </div>
      </div>
      {numpadShow && (
        <Numpad
          onSuccess={changeBetSlipTotal}
          initialValue={betSlip.total && betSlip.total.toFixed(2)}
          unit={currencyCode}
        />
      )}
      <Row
        ref={betSlipBottom}
        className={
          props.type == 'desktop'
            ? stakeExpanded
              ? 'bet-slip stakeExpanded-height'
              : 'bet-slip'
            : stakeExpanded
              ? 'bet-slip-bottom stakeExpanded-height'
              : 'bet-slip-bottom'
        }>
        {betSlip.system && betSlip.bets.length > 0 && (
          <div className="col-12 bg-anthracite">
            <div className="d-flex justify-content-between align-items-center bg-anthracite">
              <div className="text-color-white">
                <span>{t('combinations') + ' ' + combinationsText}</span>
              </div>
              <div className="text-color-white">
                <div onClick={() => setCombinationsExpanded(!combinationsExpanded)}>
                  <img
                    height={30}
                    width={30}
                    className='icon'
                    style={{
                      transform: `${!combinationsExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'}`,
                    }}
                    src={`${AWS_BUCKET_URL}/Icons/114.png`}
                    alt={'expand combination select area'}
                  />
                </div>
              </div>
            </div>
            {combinationsExpanded && (
              <div className="combination-scrollView vstack gap-1 text-start w-100 text-color-white">
                {_.uniqBy(betSlip.bets, 'providerId')
                  .filter((bet) => bet.enabled && !bet.banker)
                  .map((bet, index) => {
                    return (
                      <div key={index}>
                        <div
                          onClick={() => {
                            combinationPress(index + 1);
                          }}
                          className={
                            betSlip.combinations.includes(index + 1) && 'text-success fw-bold'
                          }>
                          <Check2Square
                            fill={betSlip.combinations.includes(index + 1) ? 'green' : 'grey'}
                            size={22}></Check2Square>
                          &nbsp;
                          {index + 1} {'from'} {combinationRelatedBetCount} {'='}
                          {combination(combinationRelatedBetCount, index + 1)} {'Betting'}
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
        )}
        <div className="d-flex justify-content-between mt-1 mb-2">
          <div className="d-flex align-items-center">
            <span className="text-white fw-bold fs-15 me-2">
              {t('pages.bettingHistoryDetail.details.stake')}
            </span>
            <button className="btn p-0" onClick={() => setStakeExpanded(!stakeExpanded)}>
              <img
                height={30}
                width={30}
                className="icon-color"
                style={{
                  transform: `${!stakeExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'}`,
                  color: 'rgba(0, 0, 0, 0.7)'
                }}
                src={`${AWS_BUCKET_URL}/Icons/114.png`}
                alt={'expand stake area'}
              />
            </button>
          </div>
          <div className="d-flex align-items-center">
            <span className="ms-auto fs-14 text-white me-2">{currencyCode}</span>
            <div className="me-1">
              <input
                inputMode="none"
                ref={stakeInput}
                onClick={() => checkNumpad()}
                className="form-control form-control-sm bg-white"
                value={betSlip.total && ConvertDisplayNumber(betSlip.total)}
                size={betSlip.total && betSlip.total.toFixed(2).replace('.', ',').length}
                readOnly
              />
            </div>
            <button
              onClick={() => changeBetSlipTotal(betSlip.total - 1)}
              className="btn btn-light btn-sm px-75 me-1">
              -
            </button>
            <button
              onClick={() => changeBetSlipTotal(betSlip.total + 1)}
              className="btn btn-light btn-sm px-75">
              +
            </button>
          </div>
        </div>
        {stakeExpanded ? (
          <div>
            <Row>
              <Col>
                <div className="float-left" style={{ color: 'white', fontSize: '14x' }}>
                  {t('pages.bettingHistoryDetail.details.numberOfBets')}
                </div>
              </Col>
              <Col>
                <div
                  className="float-right"
                  style={{
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: '800'
                  }}>
                  {numberOfBets}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="float-left" style={{ color: 'white', fontSize: '14x' }}>
                  {t('pages.bettingHistoryDetail.details.tax')}
                </div>
              </Col>
              <Col>
                <div
                  className="float-right"
                  style={{
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: '400'
                  }}>
                  {`(${ConvertDisplayNumber(taxAmount)} ${currencyCode})`}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="float-left" style={{ color: 'white', fontSize: '14x' }}>
                  {t('pages.bettingHistoryDetail.details.stakePerBet')}
                </div>
              </Col>
              <Col>
                <div
                  className="float-right"
                  style={{
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: '400'
                  }}>
                  {`(${ConvertDisplayNumber(stakePerBet)} ${currencyCode})`}
                </div>
              </Col>
            </Row>
          </div>
        ) : null}
        <Container>
          <Row>
            <Col>
              <div
                className="float-left"
                style={{
                  color: 'white',
                  fontSize: '15px',
                  paddingBottom: '4px'
                }}>
                {t('pages.bettingHistoryDetail.details.maxProfit')}
              </div>
            </Col>
            <Col className="float-right">
              <div
                className="float-right"
                style={{ color: 'yellow', fontSize: '16px', fontWeight: '700' }}>
                {`(${ConvertDisplayNumber(maxProfit)} ${currencyCode})`}
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <div className="d-flex justify-content-center gap-3">
            {showConfirmationRow ? (
              <>
                <Button
                  className="btn btn-danger flex-grow-1"
                  type="button"
                  disabled={betSlip.isBetSlipSubmitting}
                  onClick={() => setShowConfirmationRow(false)}>
                  {t('pages.betslip.cancel')}
                </Button>
                <FetchButton
                  variant="success"
                  className="flex-grow-1 w-25"
                  type="button"
                  onClick={placeBet}
                  fetching={betSlip.isBetSlipSubmitting}
                  disabled={betSlip.isBetSlipSubmitting}>
                  {t('pages.betslip.confirm')}
                </FetchButton>
              </>
            ) : (
              <div className="w-100">
                {user.isRefundBonusEnabled && refundBonusBalance > 0 && (
                  <Form.Switch
                    variant="success"
                    type="switch"
                    id="custom-switch"
                    label={t('pages.betslip.useBonusBalance')}
                    className="text-white text-start"
                    onChange={(e) => changeBonusBalance(e.target.checked)}
                    checked={useBonusBalance}
                    isValid
                  />
                )}
                <Button
                  variant="success"
                  className="placeBet-button text-center pointer w-100"
                  type="button"
                  onClick={() => setShowConfirmationRow(true)}>
                  {t('pages.betslip.placeBet')}
                </Button>
              </div>
            )}
          </div>
        </Container>
      </Row>
      <Modal
        show={betSlip.isBetSlipSubmitting}
        onHide={() => dispatch(setBetSlipSubmitting(true))}
      />
      {betSlip.responseData.success === false ? (
        <Modal show={betSlip.resultModalShow} centered backdrop="static" keyboard={false}>
          <Modal.Body className="p-4 text-center">
            <h5 className="mb-0">
              {betSlip.responseData.successState ? t('success') : t('error')}
            </h5>
            <p className="mb-0">{betSlip.responseData.text}</p>
          </Modal.Body>
          <Modal.Footer className="">
            <Button
              variant={betSlip.responseData.successState ? 'success' : 'danger'}
              size="lg"
              className="fs-6 fw-bold w-100"
              onClick={() => {
                dispatch(setResultModalShow(false));
                dispatch(setBetSlipSubmitting(false));
              }}>
              {t('continue')}
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        <Modal show={showSuccessModal} centered backdrop="static" keyboard={false}>
          <Modal.Body className="p-4 text-center">
            <h5 className="mb-0">{t('pages.betslip.successfulPlaceBet')}</h5>
            <p className="mb-0">{t('pages.betslip.successfulPlaceBetText')}</p>
          </Modal.Body>
          <Modal.Footer className="d-flex gap-3 flex-nowrap">
            <Button
              variant="danger"
              size="lg"
              className="fs-6 w-100"
              onClick={() => modalCallback(true)}>
              {t('pages.betslip.buttonModalClose', [timer])}
            </Button>
            <Button
              variant="success"
              size="lg"
              className="fs-6 fw-bold w-100"
              onClick={handleRestoreClick}>
              {t('pages.betslip.buttonModalRestoreBets')}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}
